export type PayoutRateUi = "100" | "150" | "200";

export function normalizePayoutRate(
  rawRate: string | number | null | undefined
): PayoutRateUi {
  const normalized = String(rawRate ?? "").trim().toLowerCase();

  if (normalized === "paid100" || normalized === "100") return "100";
  if (normalized === "paid150" || normalized === "150") return "150";
  if (normalized === "paid200" || normalized === "200") return "200";

  if (normalized.includes("100")) return "100";
  if (normalized.includes("150")) return "150";
  if (normalized.includes("200")) return "200";

  return "100";
}
